export default "__VITE_ASSET__B96m_KX3__"